import { IAgreementListFilter } from '../interfaces/IAgreementListFilter';
import { passportTypeOptions } from './passportTypeOptions';

export const initialAgreementListFilter: IAgreementListFilter = {
  name: 'Новый фильтр',
  types: passportTypeOptions,
  statuses: [],
  years: [],
  includeDomainChild: false,
};
